/* global jQuery COMPONENTS */

COMPONENTS.ComponentSplash = (function ($) {
  function ComponentSplash () {
    this.$component = $('[data-ecs-component="splash"]')
    this.$sliderElem = $('[data-ecs-components-control="splash-slider"]')
    this.$phoneLink = $('[data-ecs-components-control="splash-phone-link"]')

    const utility = new COMPONENTS.Utility()

    this.slidesToDisplay = (this.$sliderElem.data('ecs-components-slide-count') ? this.$sliderElem.data('ecs-components-slide-count') : 1)

    this.splashVars = utility.getSliderVars(this.slidesToDisplay)
  }

  ComponentSplash.prototype.init = function () {
    const component = this
    const utility = new COMPONENTS.Utility()
    this.$sliderElem.slick(this.splashVars)
    utility.bindSliderAriaSelected(this.$sliderElem)

    $(document).ready(function () {
      component.$phoneLink.click(function () {
        if (typeof gtag !== 'undefined') {
          gtag('event', 'Call', {
            event_category: 'Phone Link',
            event_label: 'Call'
          })
        }
      })
    })
  }

  return ComponentSplash
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentSplash = new COMPONENTS.ComponentSplash()
  COMPONENTS.componentSplash.init()
})
